import type { ReactNode } from 'react';

/** The top of a page: a small line above the title, the title, a sentence about the page, and its main actions. */
export function PageHeader({
  eyebrow,
  title,
  intro,
  actions,
  titleTestId,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  intro?: ReactNode;
  actions?: ReactNode;
  titleTestId?: string;
}) {
  return (
    <header className="page-header">
      <div className="page-header__text">
        {eyebrow ? <p className="page-header__eyebrow">{eyebrow}</p> : null}
        <h1 className="page-header__title" data-testid={titleTestId}>
          {title}
        </h1>
        {intro ? <p className="page-header__intro">{intro}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
